// extracted by mini-css-extract-plugin
export default {"snackbar":"n","appear":"o","hasType":"p"};